'use strict';

import React from 'react';

/**
 * Course Search no results message.
 */
const CourseSearchNoResults = () => {
    return (
        <div className="courseSearch-noResults mt-4">
            <h3>We couldn't find anything matching your search.</h3>
            <p>A few suggestions:</p>
            <ul>
                <li>Double-check your spelling</li>
                <li>Try a more general search, such as ENGL 1xx, A&amp;H 2 credits, etc.</li>
                <li>Select an instructor's name from the autosuggestion list instead of typing a full name</li>
                <li>Uncheck advanced options such as meeting days and times or exclusions</li>
                <li>Search the Course Catalog instead of the Time Schedule</li>
            </ul>
            <p>Still can't find what you're looking for? Go to <a href="https://itconnect.uw.edu/learn/tools/myplan-academic-planner/find-courses/" target="_blank">Find Courses guide</a></p>
        </div>
    );
};

export default CourseSearchNoResults;